var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#396ce8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.43 2h-6.86A2.274 2.274 0 0 0 8 4.57V6h5.429A2.272 2.272 0 0 1 16 8.571v7.139L20 18V4.57A2.274 2.274 0 0 0 17.43 2z",
    fill: "#396ce8",
    opacity: 1,
    "data-original": "#396ce8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.429 6H6.571A2.272 2.272 0 0 0 4 8.571V22l6-3.428L16 22V8.571A2.272 2.272 0 0 0 13.429 6z",
    opacity: 1,
    fill: "#396ce840",
    "data-original": "#396ce840",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.347 9.646.7 1.414a.359.359 0 0 0 .272.2l1.619.234a.36.36 0 0 1 .2.615l-1.17 1.136a.361.361 0 0 0-.105.32l.268 1.554a.386.386 0 0 1-.561.407l-1.4-.734a.357.357 0 0 0-.336 0l-1.4.734a.387.387 0 0 1-.562-.408l.268-1.553a.361.361 0 0 0-.105-.32L6.86 12.107a.36.36 0 0 1 .2-.615l1.619-.234a.359.359 0 0 0 .272-.2l.7-1.414a.387.387 0 0 1 .696.002z",
    fill: "#396ce8",
    opacity: 1,
    "data-original": "#396ce8",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooked);
export default __webpack_public_path__ + "static/media/booked.11d8c06ba9d5b53a04d5ff8626243ec0.svg";
export { ForwardRef as ReactComponent };